import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23e17bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper my-4 py-5 pb-20" }
const _hoisted_2 = { class: "px-3 rounded my-2 lg:rounded-2xl lg:shadow-xs drop-shadow-sm" }
const _hoisted_3 = { class: "flex items-center rounded-lg" }
const _hoisted_4 = { class: "m-auto" }
const _hoisted_5 = {
  key: 0,
  class: "w-20 h-20 rounded-full mx-auto bg-gray-300 dark:bg-gray-800 animate-pulse"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center appFont mt-2 text-xl space-x-1"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "hover:bg-gray-100 dark:hover:bg-gray-800 p-0.5 rounded" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-primary-300" }
const _hoisted_11 = { class: "text-gray-400 dark:text-gray-600" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 rounded w-[50%] md:w-[25%] mx-auto p-1 bg-gray-300 dark:bg-gray-800 animate-pulse" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-5 gap-2 w-[65%] md:w-[35%] mx-auto" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4 rounded p-1 bg-gray-300 dark:bg-gray-800 animate-pulse col-span-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4 rounded p-1 bg-gray-300 dark:bg-gray-800 animate-pulse" })
], -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "mt-10 grid grid-cols-3 grid-rows-1" }
const _hoisted_18 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  key: 0,
  class: "my-7 w-full px-5 h-[150px] bg-gray-300 dark:bg-gray-800 animate-pulse rounded-lg flex items-center justify-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10 text-gray-100 dark:text-gray-600",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "wrapper my-4 py-5 pb-20 text-center"
}
const _hoisted_27 = { class: "appFont text-3xl" }
const _hoisted_28 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titleFont text-xl" }, "Aren't you looking for one of them?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileImageLazy = _resolveComponent("ProfileImageLazy")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Premium = _resolveComponent("Premium")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_UserFollowBox = _resolveComponent("UserFollowBox")!
  const _component_Separator = _resolveComponent("Separator")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dots = _resolveComponent("Dots")!
  const _component_Guess = _resolveComponent("Guess")!
  const _component_LinksSheet = _resolveComponent("LinksSheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.loaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : (_openBlock(), _createBlock(_component_ProfileImageLazy, {
                  key: 1,
                  "premium-cube": _ctx.premiumCubeImage,
                  user: _ctx.user
                }, null, 8, ["premium-cube", "user"])),
            (_ctx.loaded)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [
                  _createVNode(_component_Tippy, { content: "Copy username" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyUsername && _ctx.copyUsername(...args)))
                      }, "@" + _toDisplayString(_ctx.user.username), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Tippy, { content: "Premium subscriber" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Premium, { class: "text-purple-300 cursor-pointer" })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.loaded && _ctx.bio)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 3,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.bioLimit = !_ctx.bioLimit)),
                  class: _normalizeClass(["transition-transform duration-150 mt-3 cursor-pointer text-gray-700 dark:text-gray-300 text-sm sm:w-[80%] sm:mx-auto flex items-end", {'bg-gray-100 dark:bg-gray-800 p-1 rounded': !_ctx.bioLimit}])
                }, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.bio,
                    class: _normalizeClass({'bio-hider': _ctx.bioLimit})
                  }, null, 10, _hoisted_7),
                  _createVNode(_component_Tippy, { content: "Show/Hide full bio" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", _hoisted_8, [
                        _createVNode(_component_Expand)
                      ])
                    ]),
                    _: 1
                  })
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Tippy, { content: "Show all link" }, {
                default: _withCtx(() => [
                  (_ctx.loaded && _ctx.user.bio_links.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linksSheet = true)),
                        class: "small"
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.url(_ctx.user.bio_links[0].real_url).hostname), 1),
                        _createElementVNode("span", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.url(_ctx.user.bio_links[0].real_url).pathname.substring(0, 10)), 1),
                          (_ctx.url(_ctx.user.bio_links[0].real_url).pathname.length > 10)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "..."))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (!_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
          : _createCommentVNode("", true),
        (!_ctx.failed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("section", _hoisted_17, [
                _createVNode(_component_UserFollowBox, {
                  title: "Followers",
                  count: _ctx.user.followers_count
                }, null, 8, ["count"]),
                _createVNode(_component_UserFollowBox, {
                  title: "Following",
                  count: _ctx.user.followings_count
                }, null, 8, ["count"]),
                _createVNode(_component_UserFollowBox, {
                  title: "Points",
                  count: _ctx.user.points
                }, null, 8, ["count"])
              ]),
              _createVNode(_component_Separator),
              _createElementVNode("section", _hoisted_18, [
                (!_ctx.loaded)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_Button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Spinner)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Button, { "gray-theme": true }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Spinner)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_Button, null, {
                        default: _withCtx(() => [
                          (_ctx.user.is_followed)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Unfollow"))
                            : (_ctx.user.if_private_is_requested)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Requested"))
                              : (_ctx.user.is_follows)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Follow back"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_22, "Follow"))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Button, { "gray-theme": true }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Dots)
                        ]),
                        _: 1
                      })
                    ], 64))
              ]),
              (!_ctx.failed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.not_found ? 'User not found' : 'Something went wrong'), 1),
              (_ctx.not_found)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_Separator),
                    _createVNode(_component_Guess, {
                      username: _ctx.$route.params.username
                    }, null, 8, ["username"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ]),
    (_ctx.linksSheet)
      ? (_openBlock(), _createBlock(_component_LinksSheet, {
          key: 0,
          links: _ctx.user.bio_links,
          "show-sheet": _ctx.linksSheet,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linksSheet = false))
        }, null, 8, ["links", "show-sheet"]))
      : _createCommentVNode("", true)
  ], 64))
}